export default function MainFrame({ refId = null, width, children }) {
  return (
    <div
      ref={refId}
      className="submenu"
      style={{
        width: width + "%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
}
